import { render, staticRenderFns } from "./TemplateOne.vue?vue&type=template&id=770cad3c&scoped=true&"
import script from "./TemplateOne.vue?vue&type=script&lang=js&"
export * from "./TemplateOne.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOne.vue?vue&type=style&index=0&id=770cad3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770cad3c",
  null
  
)

export default component.exports